export const BIOACTIVITY_PANEL_FLAG_ID = 2;
export const FULL_PRODUCT_REPORT_FLAG_ID = 3;
